import api, { unwrap } from './client'
import type { PullRequest, PullRequestFilters } from '@/types/models'

export const openPullRequestsApi = {
  async list(filters: PullRequestFilters = {}): Promise<PullRequest[]> {
    const params: Record<string, string> = {}
    if (filters.view) params.view = filters.view

    return (await unwrap(api.get<{ data: PullRequest[] }>('/open-pull-requests', { params }))) ?? []
  },

  // Stamps the viewer's last_viewed_at for this PR — called the moment it's
  // opened/expanded from the list, not on page load.
  async markViewed(id: string): Promise<void> {
    await api.post(`/open-pull-requests/${id}/view`)
  },

  // Re-requests the PR's currently-failed GitHub check runs.
  async retryCi(id: string): Promise<void> {
    await api.post(`/open-pull-requests/${id}/retry-ci`)
  },

  // Queues a fresh AI review run for the PR, bypassing the PR-comment command.
  async retryReview(id: string): Promise<void> {
    await api.post(`/open-pull-requests/${id}/retry-review`)
  },
}
